<script>
  import { onMount, getContext } from 'svelte'
  import { mapRange, rotate } from '../util/math'
  import Symbol from './symbol.svelte'
  import Wave from './wave.svelte'

  export let cx
  export let cy
  export let rotation = 0
  export let amplitude = 12
  export let frequency = 3
  export let phase = 0
  export let offset = { x: 0, y: 0 }
  export let numWaves = 10
  export let waveRotation = 0

  const animate = getContext('animate')

  let store = getContext('store')
  $: [startX, startY] = [cx - $store.width, cy]

  let waves = []
  let symbols = []

  $: isWithinBounds = ([x, y]) => {
    return x > 0 && x <= $store.width && y > 0 && y <= $store.height
  }

  function value(x, t, i) {
    return typeof x === 'function' ? x(t, i) : x
  }

  onMount(() => {
    let raf

    function loop(t) {
      raf = requestAnimationFrame(loop)
      render(t)
    }

    function render(t) {
      waves = Array.from({ length: numWaves }).map((_, i) => {
        const a = value(amplitude, t, i)
        const f = value(frequency, t, i)
        const p = value(phase, t, i)
        const offsetX = value(offset.x, t)
        const offsetY = value(offset.y, t)
        let coords = []
        let x =
          startX + mapRange(i, 0, numWaves, (-offsetX * numWaves) / 2, (offsetX * numWaves) / 2)
        let y =
          startY + mapRange(i, 0, numWaves, (-offsetY * numWaves) / 2, (offsetY * numWaves) / 2)

        for (let dx = x; dx < cx + $store.width; dx += 2) {
          let dy = y + a * Math.sin(dx * f + p)
          let xy = rotate(cx, cy, dx, dy, rotation + waveRotation * i)
          if (isWithinBounds(xy)) {
            coords.push(xy)
          }
        }
        return coords
      })
    }

    function createSymbol(type) {
      const allCoords = waves.flat()
      return {
        type,
        pos: allCoords[Math.floor(Math.random() * allCoords.length)],
        size: 5 + Math.random() * 20,
        delay: Math.random() * 1000,
      }
    }

    const symbolType = ['circle', 'square', 'triangle'][Math.floor(Math.random() * 3)]

    if (animate) {
      raf = requestAnimationFrame(loop)
    } else {
      raf = requestAnimationFrame(render)
    }
    requestAnimationFrame(() => {
      symbols = Array.from({ length: mapRange($store.width, 300, 3000, 5, 20, true) }).map(() =>
        createSymbol(symbolType)
      )
    })

    return () => cancelAnimationFrame(raf)
  })
</script>

{#each waves as coords}
  <Wave {coords} />
{/each}

{#each symbols as symbol}
  <Symbol {...symbol} />
{/each}
